/* tslint:disable */
/* eslint-disable */
export enum GenderType {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NOT_KNOWN = 'NOT_KNOWN'
}
